import { render, staticRenderFns } from "./tablepage.vue?vue&type=template&id=02280270"
import script from "./tablepage.vue?vue&type=script&lang=js"
export * from "./tablepage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports